export default {
      id: "gulp-usage",
      viewBox: "0 0 175 387",
      url: __webpack_public_path__ + "img/icons.1563a6ab.svg#gulp",
      toString: function () {
        return this.url;
      }
    }